<template>
  <div>
    <section v-if="propProtocolo.partes">
      <div>
        <div class="d-flex col-12 m-0 p-0">
          <div class="col-3 m-0 p-0">
            <span>Nº Protocolo:</span><br>
            <b>{{ propProtocolo.numero + "/" +propProtocolo.ano }}</b>
          </div>
          <div class="col-3 m-0 p-0">
            <span>Data do lançamento:</span><br>
            <b>{{ propProtocolo.created_at | date }}</b>
          </div>
          <div class="col-3 m-0 p-0">
            <span>Tipo registro:</span><br>
            <b>{{ formatTipoRegistroText(propProtocolo.tipo_registro) }}</b>
          </div>
          <div class="col-3 d-flex justify-content-end m-0 p-0">
            <div>
              <span class="text-success">{{ propProtocolo.logs[propProtocolo.logs.length - 1].status }}</span><br>
              <b class="text-success">{{ propProtocolo.logs[propProtocolo.logs.length - 1].created_at | date }}</b>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap col-12 m-0 p-0 mt-3">
          <div class="col-3 m-0 p-0">
            <span>Natureza:</span><br>
            <b>{{ propProtocolo.natureza }}</b>
          </div>
          <div v-for="info of propProtocolo.informacoes"
               :key="info.id">
            <div v-if="info && info.chave === 'matricula' && propProtocolo.registro"
                 class="col-3 m-0 p-0">
              <span>{{ capitalizarPrimeiraLetra(info.chave) }}:</span><br>
              <b-link
                v-b-tooltip.hover.right="'Ir para registro'"
                target="_blank"
                :to="getUrl()">
                <b>{{ info.valor }}</b>
              </b-link>
            </div>
          </div>
          <div class="col-12 m-0 p-0 mt-3">
            <span>Informações adicionais:</span><br>
            <div v-for="info of propProtocolo.informacoes"
                 :key="info.id">
              <div v-if="info && !info.chave === 'matricula'"
                   class="col-3 m-0 p-0">
                <span>{{ capitalizarPrimeiraLetra(info.chave) }}:</span><br>
                <b>{{ info.valor }}</b>
              </div>
            </div>
            <span else>---</span>
          </div>
        </div>

        <div>
          <div v-for="parte of propProtocolo.partes"
               :key="parte.id"
               class="d-flex col-12 m-0 p-0 mt-3">
            <div class="col-2 m-0 p-0">
              <span>Nº CPF/CNPJ:</span><br>
              <b v-if="parte.cpf.length > 13">{{ parte.cpf | cnpj }}</b>
              <b v-else>{{ parte.cpf | cpf }}</b> 
            </div>
            <div class="col-3 m-0 p-0">
              <span>Requerente:</span><br>
              <b>{{ parte.nome }}</b>
            </div>
          </div>
        </div>
        <hr>
        <div v-if="propProtocolo.observacao"
             class="d-flex flex-column mt-2 mb-2">
          <label for="">Observações:</label>
          <b>{{ propProtocolo.observacao }}</b>
        </div>
        <div v-if="propProtocolo.motivo_cancelamento"
             class="m-0 p-0 mt-3">
          <hr>
          <div class="d-flex flex-column">
            <label>Motivo do cancelamento</label>
            <b>{{ propProtocolo.motivo_cancelamento }}</b>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

  // Constants
  import { obterLabelPorValorRegistro } from "@/constants/registro"

  export default {
    name: "ProtocoloParte",
    components: {
    },
    props: {
      propProtocolo: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        protocolo: null,
      }
    },
    computed: {
      computedMatricula () {
        return !!this.propProtocolo?.partes.find(item => item.chave === 'matricula')
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
       
      },
      capitalizarPrimeiraLetra (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      formatTipoRegistroText (value) {
        return obterLabelPorValorRegistro(value)
      },
      getUrl () {
        const registro = this.propProtocolo.registro
        if (!registro) return console.log('Registro não encontrado')
        let url = null

        switch (registro.tipo_registro) {
        case 'C': case 'CR':
          url = { name: 'resumo_casamento', params: { id: registro.casamento.casamento_id } }
          break
        case 'D':
          url = { name: 'resumo_habilitacao_casamento', params: { id: registro.habilitacaoCasamento.habilitacao_casamento_id } }
          break
        case 'O': case 'NT':
          url = { name: 'resumo_obito', params: { id: registro.obito.obito_id } }
          break
        case 'N':
          url = { name: 'resumo_nascimento', params: { id: registro.nascimento.nascimento_id } }
          break
        }

        return url
      },
     
    }
  }
</script>

<style scoped>

</style>
